export enum GasType {
    "", "EBEM Aardgas Variabel" = 64764978, "EBEM G@s +" = 64765005
}